export default {
    devices_tab_label: 'Etiqueta',
    devices_tab_status: 'Estado',
    devices_tab_reference: 'Referencia',
    devices_tab_manufacturer: 'Fabricante',
    devices_tab_model: 'Modelo',
    devices_tab_serial: 'Serial',
    devices_tab_imei: 'IMEI',
    devices_tab_linked_device_label: 'Unidad Emparejada',
    devices_tab_linked_device: 'Serial de la Unidad GPS',
    devices_tab_sim_number: 'SIM #',
    devices_tab_sim_phone: 'Teléfono SIM',
    devices_tab_network: 'Red',
    devices_tab_sim_provider_account: 'Cuenta del Proveedor de SIM',
    devices_tab_unit_time: 'Fecha de la unidad',
    devices_tab_server_time: 'Fecha del servidor',
    devices_tab_last_message_time: 'Hora del último mensaje',
    devices_tab_age: 'Antiguedad',

    devices_tab_edit: 'Editar',
    devices_tab_editswap_sim_card: 'Editar e intercambiar la tarjeta Sim',
    devices_tab_send_command: 'Enviar comando',
    devices_tab_change_device_script: 'Cambiar la secuencia de comandos del dispositivo',
    devices_tab_change_sim_provider: 'Cambiar de proveedor de SIM',
    devices_tab_refresh_config_status: 'Actualizar el estado de la configuración',
    devices_tab_change_PULS_customer: 'Cambiar el cliente PULS',
    devices_tab_bulk_vidfleet_Config: 'Configuración masiva de Vidfleet',
    devices_tab_assign_firmware: 'Asignar el Firmware',
    devices_tab_activate_cameras_sim_card: 'Activar la Tarjeta SIM de la Cámara',
    devices_tab_bulk_vidfleet_config_upload_mode: 'Modo de carga masiva de Vidfleet Config',
    devices_tab_bulk_pairing: 'Emparejamiento masivo',
    devices_tab_unpair: 'Desemparejar',
    devices_tab_firmware: 'Firmware',
    devices_tab_move_to_another_account: 'Mover a otra cuenta',
    devices_tab_mark_as_rma: 'Marcar como RMA',
    devices_tab_change_status: 'Cambiar el estado',
    devices_tab_change_status_warning: 'No es posible cambiar el estado a dispositivos renovados',
    devices_tab_sim_provider: 'Proveedor de SIM',
    devices_tab_puls_group: "Grupo",
    devices_tab_rma_selected: "Hay dispositivos RMA seleccionados",
    devices_tab_linked_camera: 'Serial de la Cámara',
    devices_tab_change_timezone: 'Cambiar la Zona horaria',
    devices_tab_change_timezone_warning: 'No es posible cambiar la zona horaria de dispositivos renovados',
    devices_tab_change_warning_message_calamp_api: 'Los dispositivos seleccionados deben ser de la misma api de Calamp',
    devices_tab_bulk_vidfleet_config_hubspot: 'Configurar VidFleet HotSpot Masivo',
    devices_tab_id: "Id",
    devices_tab_change_status_active_message: "No se puede cambiar el estado de los dispositivos activos",
    devices_tab_assign_unassign_billing_account: "Asignar/Desasignar Cuenta de Facturación",
};